export default __webpack_public_path__ + "static/media/2019 Bluegrass.354ff977.pdf";